/**
 * bootprompt.js locale configuration
 * locale : Latvian
 * author : Dmitry Bogatykh, Lauris BH
 */

import { addLocale } from "../bootprompt";

addLocale("lv", {
  OK: "Labi",
  CANCEL: "Atcelt",
  CONFIRM: "Apstiprināt",
});
